import { useEffect, useMemo, useRef, useState } from 'react';
import { throttle } from 'throttle-debounce';

const GAP = '1ch';

export const useFixedSticky = (top: number | string, fitViewport?: boolean): CSSProperties => {
    const [topOffset, setTopOffset] = useState<number | string>(top);
    const scrollRef = useRef(document.documentElement);

    useEffect(() => {
        const handleScroll = throttle(100, (_event: any): void => {
            const topScroll = scrollRef.current.scrollTop;
            if (topScroll <= Number(top)) {
                setTopOffset(Number(top) - topScroll);
            } else {
                setTopOffset(GAP);
            }
        });
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [top]);

    useEffect(() => {
        setTopOffset(top);
    }, [top]);

    return useMemo(
        () => ({
            top: topOffset,
            height: fitViewport
                ? `calc(100vh - ${typeof topOffset === 'string' ? topOffset : topOffset + 'px'})`
                : undefined,
            position: 'fixed',
        }),
        [fitViewport, topOffset],
    );
};
